// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1A5Lh","header":"Messages_header__2sHMj"};